export default "/images/a72bdd643e5a725e5f2bd4a505d1c5c6.avif";